import React from 'react';
import { DragAndDrop, FileSelector } from '@carvana/purchase-helpers';
import * as sharedPayStubModalStyles from '../../document-wizard-modal.styles';
import * as fileUploadStyles from './document-select.styles';

const sc = { ...sharedPayStubModalStyles, ...fileUploadStyles };

const acceptableFiles = '.jpeg, .jpg, .png, .pdf';

const DocumentSelectPaystubs = props => {
  const { document, wizardConfig, handleSelectedFile, goToStep } = props;

  const fileSelected = files => {
    handleSelectedFile({ document, selectedFile: files[0] });
    goToStep();
  };

  return (
    <DragAndDrop
      acceptableFiles={acceptableFiles}
      fileDropLimit={1}
      handleDroppedFile={fileSelected}
    >
      <sc.DocumentSelectHeading>
        {wizardConfig.heading}
      </sc.DocumentSelectHeading>
      <sc.DocumentSelectSubheading>
        This pay stub must be your {document.docId === 2 && '2nd'} most recent
        and{' '}
        <b>dated within the last {document.docId === 1 ? '35' : '70'} days.</b>
      </sc.DocumentSelectSubheading>

      <sc.DragDropText>
        Drag your file or click the button to upload
      </sc.DragDropText>
      <sc.FileSelectorWrapper>
        <FileSelector
          handleSelectedFile={fileSelected}
          acceptableFiles={acceptableFiles}
        >
          Upload
        </FileSelector>
      </sc.FileSelectorWrapper>
    </DragAndDrop>
  );
};

export default DocumentSelectPaystubs;
